import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const testimonials = [
  {
    name: 'Va Te',
    location: 'Google Bewertung',
    text: 'Die von uns beim Umzug versehentlich durchbohrte Elektroleitung wurde noch abends im Notdienst repariert. Ein paar Wochen später die altersbedingt durchgeschmorte Herddose. Schnell, freundlich, zuverlässig und faire Preise. Wir können die Firma Daniels absolut empfehlen!',
    rating: 5,
    project: 'Notdienst & Reparatur',
  },
  {
    name: 'Peter Bertram',
    location: 'Google Bewertung',
    text: 'Wir waren sehr zufrieden und können die Firma Daniels uneingeschränkt weiterempfehlen. Die Mitarbeiter sind pünktlich, arbeiten sauber und die Preise sind angemessen.',
    rating: 5,
    project: 'Elektroinstallation',
  },
  {
    name: 'Bonn 1898',
    location: 'Google Bewertung',
    text: 'Sehr freundlich, schnell und saubere Arbeit zum top Preis. Auch bei einem größeren Elektro-Problem im Haus/Altbau findet die Fa. Daniels eine perfekte Lösung. Danke!',
    rating: 5,
    project: 'Altbau-Lösung',
  },
];

export default function BewertungenSection() {
  return (
    <section id="bewertungen" data-testid="bewertungen-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <span className="text-[#10B981] font-['Manrope'] text-sm font-semibold tracking-[0.2em] uppercase">
            Kundenstimmen
          </span>
          <h2 className="font-['Outfit'] text-4xl sm:text-5xl font-bold text-[#1A3A22] tracking-tight mt-3 mb-4">
            Das sagen unsere Kunden in <span className="text-[#2D5A27]">Bonn</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((review, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.15 }}
              data-testid={`testimonial-${idx}`}
              className="card-3d bg-white border border-gray-100 p-8 relative"
            >
              {/* Project tag */}
              <span className="inline-block bg-[#F4F8F4] text-[#2D5A27] font-['Manrope'] text-xs font-semibold px-3 py-1 mb-5 tracking-wider uppercase">
                {review.project}
              </span>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-[#2D5A27] fill-[#2D5A27]" />
                ))}
              </div>

              <p className="font-['Manrope'] text-gray-700 text-base leading-relaxed mb-6 italic">
                &ldquo;{review.text}&rdquo;
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 bg-[#2D5A27] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-['Outfit'] font-bold text-sm">
                    {review.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <span className="font-['Outfit'] text-[#1A3A22] font-semibold text-sm block">
                    {review.name}
                  </span>
                  <span className="font-['Manrope'] text-gray-500 text-xs">{review.location}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
